import {
  AddBusinessOutlineMediumIcon,
  ButtonNormalSecondaryMedium,
  ButtonWrapper,
  CardInfo,
  DividerHorizontal,
  ForumOutlineMediumIcon,
  GroupElement,
  GroupElementGrid,
  TextHeading2,
  TextParagraph,
} from '@ferreri/prever-component-lib';
import { SETTINGS } from '../../config/settings';
import { StyledSection } from '../../components/layouts/Layouts';

const URL_PARTNER_WEB = `${SETTINGS.public.urlPartnerWeb}/companies`;

export const HomePartnerSection = () => {
  return (
    <StyledSection>
      <DividerHorizontal />
      <TextHeading2>Seja parceiro e anuncie no Clube!</TextHeading2>
      <GroupElementGrid>
        <CardInfo
          icon={<AddBusinessOutlineMediumIcon />}
          title="Parceiro do Clube"
        >
          <GroupElement>
            <TextParagraph>
              Cadastre seu negócio e crie anúncios no Clube de Vantagens.
            </TextParagraph>
            <ButtonWrapper
              onClick={() => document.location.assign(URL_PARTNER_WEB)}
            >
              <ButtonNormalSecondaryMedium>
                Anunciar no Clube
              </ButtonNormalSecondaryMedium>
            </ButtonWrapper>
          </GroupElement>
        </CardInfo>
        <CardInfo icon={<ForumOutlineMediumIcon />} title="Dúvidas e sugestões">
          <GroupElement>
            <TextParagraph>
              Tem dúvidas, sugestões, elogios ou reclamações sobre o Clube? Fale
              conosco.
            </TextParagraph>
            <ButtonWrapper
              onClick={() =>
                window.open(
                  'mailto:parcerias@grupopreversul.com.br',
                  '_blank',
                  'noopener noreferrer',
                )
              }
            >
              <ButtonNormalSecondaryMedium>
                Entrar em contato
              </ButtonNormalSecondaryMedium>
            </ButtonWrapper>
          </GroupElement>
        </CardInfo>
      </GroupElementGrid>
    </StyledSection>
  );
};
